export default __webpack_public_path__ + "static/media/Krystal_Henry_AHV_In_Moms_We_Trust.d6f7ebd0.jpg";